module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_1",
      "title": "1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Author-ca"
  }, [_vm._v("Willa")]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_c('span', [_vm._v("I")]), _vm._v(" can tell you exactly when I lost my will to live.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("It was three years ago. The day I found out my husband, Ben, who I’d contentedly believed was happily working on our beach house in Ocean City, Maryland, and getting ready to come home at the end of a long weekend, had actually died quietly in his sleep there.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("That was when I, Willa Bennett, effectively ceased to be. That’s when the Willa who could laugh easily and speak her mind confidently went quiet. That’s when the Willa who enjoyed a largely anxiety-free life could no longer drape over the end of the sofa and have a conversation, and began, instead, to be a tight bundle of nerves. That’s when the Willa who could accept an unanswered phone as less than alarming became the kind of person who freaked out instantly if her son didn’t answer a call or text. It had already happened a few times, when Ben didn’t respond because he was driving, or he’d forgotten to charge his phone, or he was busy with power tools, and I’d jumped to the conclusion each time that he was "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_2",
      "title": "2"
    }
  }, [_vm._v("actually lying dead, alone and unattended for perhaps a whole day. Sunrise and sunset, and sunrise again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Three years ago. That’s when the Willa who believed in happily-ever-after and joy grew lonely, afraid, and hollow. That’s when she lost all hope, and even a slew of medications and meditations couldn’t bring her back.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("That’s when I became Dead Willa.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Dead Willa, who, three years after the fact—tired of knowing that damnable house was still sitting there, untouched, since Ben had died—decided it was finally time to get rid of the place. The house had become an empty tomb, a sad monument to what had once been, what had happened, and what would never be again.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I finally decided that I had to be present for my now-seventeen-year-old son before I blinked again and he was twenty-one, and so on right through all the lyrics of “Cat’s in the Cradle.” I had become an incomplete person the moment he lost his father, when he needed me most. It was time—well past time, actually—for me to pull myself up by the bootstraps and join life again.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The only way to do that was to face the house. To move in for the summer—easily done, as I am an English teacher at a private high school in Potomac and had the summer off—fix it up, and get the place sold.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Did I mention that the old Willa didn’t believe in ghosts? Much as she might have wanted to, she just couldn’t bring herself to buy in. Ghosts and spirits and psychics and tarot cards—it was all nonsense to her.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But she believes now.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba8dfc14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 75
// module chunks = 0